/** @format */

import React from "react";
import styled from "styled-components";
import { FaHome } from "react-icons/fa";
import { MdPointOfSale } from "react-icons/md";
import { AiFillMessage, AiOutlineLogout, AiOutlineFund } from "react-icons/ai";
import { GoPerson } from "react-icons/go";
import { MdHealthAndSafety } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { UseAppDispach } from "../Global/Store";
import { logout } from "../Global/ReduxState";
import { Link } from "react-router-dom";

const SideBar = () => {
  const dispatch = UseAppDispach();

  return (
    <>
      <Body>
        <Contain>
          <Top>
            <Admin>USER</Admin>

            <NavLink
              to="/dashboardhome"
              style={({ isActive }) => {
                return {
                  textDecoration: isActive ? "none" : "none",
                  color: isActive ? "yellow" : "white",
                };
              }}
            >
              <Home>
                <Icon>
                  <FaHome />
                </Icon>

                <HomeText>Home</HomeText>
              </Home>
            </NavLink>

            <NavLink
              to="/transactions"
              style={({ isActive }) => {
                return {
                  textDecoration: isActive ? "none" : "none",
                  color: isActive ? "yellow" : "white",
                };
              }}
            >
              <Home>
                <Icon>
                  <MdPointOfSale />
                </Icon>

                <HomeText>Transactions</HomeText>
              </Home>
            </NavLink>

            <NavLink
              to="/makeappointment"
              style={({ isActive }) => {
                return {
                  textDecoration: isActive ? "none" : "none",
                  color: isActive ? "yellow" : "white",
                };
              }}
            >
              <Home>
                <Icon>
                  <GoPerson />
                </Icon>

                <HomeText>Appointment</HomeText>
              </Home>
            </NavLink>

            <NavLink
              to="/hmo"
              style={({ isActive }) => {
                return {
                  textDecoration: isActive ? "none" : "none",
                  color: isActive ? "yellow" : "white",
                };
              }}
            >
              <Home>
                <Icon>
                  <MdHealthAndSafety />
                </Icon>

                <HomeText>
                  HMO <br />{" "}
                  <span
                    style={{
                      color: "#a8ff37",
                      fontWeight: "700",
                      fontSize: "10px",
                    }}
                  >
                    coming soon!
                  </span>
                </HomeText>
              </Home>
            </NavLink>

            <NavLink
              to="/fundwallet"
              style={({ isActive }) => {
                return {
                  textDecoration: isActive ? "none" : "none",
                  color: isActive ? "yellow" : "white",
                };
              }}
            >
              <Home>
                <Icon>
                  <AiOutlineFund />
                </Icon>

                <HomeText>Fund Wallet</HomeText>
              </Home>
            </NavLink>

            <NavLink
              to="/settings"
              style={({ isActive }) => {
                return {
                  textDecoration: isActive ? "none" : "none",
                  color: isActive ? "yellow" : "white",
                };
              }}
            >
              <Home>
                <Icon>
                  <AiFillMessage />
                </Icon>

                <HomeText>Settings</HomeText>
              </Home>
            </NavLink>
          </Top>

          <Bottom>
            <Home>
              <Icon>
                <AiOutlineLogout />
              </Icon>

              <Link
                style={{ textDecoration: "none", color: "white" }}
                to={"/signin"}
              >
                <HomeText
                  onClick={() => {
                    dispatch(logout());
                  }}
                >
                  Logout
                </HomeText>
              </Link>
            </Home>
          </Bottom>
        </Contain>
      </Body>
    </>
  );
};

export default SideBar;

// const DashHead = styled.div``;

// const DashHead = styled.div``;

// const DashHead = styled.div``;

const Bottom = styled.div``;

const HomeText = styled.div`
  font-size: 14px;
  // color: #e4e932;
  font-weight: 700;
`;

const Icon = styled.div`
  font-size: 15px;
  margin-right: 10px;
  color: #a8ff37;
`;

const Home = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
`;

const Admin = styled.div`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 30px;
  // color: #a8ff37;
  color: white;
`;

const Top = styled.div``;

const Contain = styled.div`
  width: 90%;
  height: 90%;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // align-items: center;
  margin-left: 30px;
`;

const Body = styled.div`
  width: 250px;
  height: calc(100vh - 65px);
  display: flex;
  /* justify: content; */
  align-items: center;
  position: fixed;
  // background-color: #1f1f1f;
  background-color: #8a2be2;
`;
